import PayrollDashboard from './pages/PayrollDashboard.vue';
import PayrollPeriod from './pages/PayrollPeriod.vue';
import PayrollReport from './pages/PayrollReport.vue';
import EmployeePayrollOverview from './pages/EmployeePayrollOverview.vue';
import PayrollPeriodView from './pages/PayrollPeriodView.vue';

export default {
  'payroll-module': PayrollDashboard,
  'payroll-period': PayrollPeriod,
  'payroll-report-list': PayrollReport,
  'epp-payroll-overview': EmployeePayrollOverview,
  'view-payroll-period': PayrollPeriodView,
};
